<template>
  <div>
    <h1>{{ $t("tripPlan.edit") }}</h1>
    <success-fade-alert ref="alert" :msg="alert.success" />
    <fade-alert-danger ref="fadeAlertDanger" :msg="alert.error" />
    <path-crud
      ref="crud"
      :model="model"
      :isEdit="true"
      :modelstate="modelstate"
    ></path-crud>
    <!-- {{ model }} -->

    <b-button @click="save()" :disabled="submitted">
      {{ $t("geral.save") }}
    </b-button>
  </div>
</template>
<script>
export default {
  name: "ProcessPathEdit",
  props: {
    id: String,
  },
  components: {
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
    PathCrud: () => import("@/components_rms/workflow/Path/PathCrud.vue"),
  },
  created() {
    this.loadData();
  },
  data() {
    return {
      alert: {
        error: "",
        success: "Registro criado com sucesso",
      },
      submitted: false,
      model: {},
      modelstate: {},
    };
  },
  methods: {
    loadData() {
      this.$apiWorkflow.get("/tripPlan/get/" + this.id).then((response) => {
        this.model = response.data;
        // setTimeout(() => this.$refs.crud.loadMapRoute(), 500);
      });
    },
    save() {
      this.submitted = true;
      this.$apiWorkflow
        .post("/tripPlan/save/", this.model)
        .then((response) => {
          // console.log(response)
          this.model = response.data;
          this.$forceUpdate();
          this.$refs.alert.show();
          this.modelstate = {};
          this.submitted = false;
        })
        .catch((error) => {
          console.log(error.response);
          this.submitted = false;
          this.modelstate = {};
          if (error.response) {
            if (error.response.status == 400) {
              if (error.response.data.errors) {
                this.modelstate = error.response.data.errors;
              } else {
                this.modelstate = error.response.data;
              }
              this.alert.error = error.message;
            } else if (error.response.status == 404) {
              console.log("ok");
              console.log(error.response.data);
              this.alert.error = error.response.data.message;
            } else {
              if (error.response.data) {
                console.log(error.response.data);
                this.alert.error = `${error.response.status} - ${error.response.statusText} `;
              } else {
                this.alert.error = `${error.response.status} - ${error.response.statusText} `;
              }
            }
          } else {
            this.alert.error = error.message;
          }
          this.$refs.fadeAlertDanger.show();
        });
    },
  },
};
</script>
